import { createSlice } from '@reduxjs/toolkit';

/** LocalStorage helpers */
const STORAGE_KEY = 'confluenceJobs';

const loadJobsFromStorage = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch (e) {
        console.error('Failed to load confluence jobs from storage', e);
        return [];
    }
};

const persistJobsToStorage = (jobs) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(jobs));
    } catch (e) {
        console.error('Failed to persist confluence jobs to storage', e);
    }
};

const initialState = {
    open: false,
    jobs: loadJobsFromStorage()
};

const confluenceJobsSlice = createSlice({
    name: 'confluenceJobs',
    initialState,
    reducers: {
        openJobsDialog(state) {
            state.open = true;
        },

        closeJobsDialog(state) {
            state.open = false;
        },

        addJob(state, action) {
            state.jobs.unshift({
                ...action.payload,
                createdAt: Date.now()
            });
            persistJobsToStorage(state.jobs);
        },

        updateJob(state, action) {
            const { jobId, updates } = action.payload;
            const job = state.jobs.find(j => j.jobId === jobId);

            if (job) {
                Object.assign(job, updates);
                persistJobsToStorage(state.jobs);
            }
        },

        acknowledgeJob(state, action) {
            state.jobs = state.jobs.filter(j => j.jobId !== action.payload);
            persistJobsToStorage(state.jobs);
        },

        clearAllJobs(state) {
            state.jobs = [];
            localStorage.removeItem(STORAGE_KEY);
        }
    }
});

/** Exports */
export const {
    openJobsDialog,
    closeJobsDialog,
    addJob,
    updateJob,
    acknowledgeJob,
    clearAllJobs
} = confluenceJobsSlice.actions;

export default confluenceJobsSlice.reducer;
